/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/RecommendedArticles/theme';

export const RecommendedArticlesTheme = theme;
